import { render } from "./ResetPassword.vue?vue&type=template&id=757bb2da"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"

import "./ResetPassword.vue?vue&type=style&index=0&id=757bb2da&lang=css"

import exportComponent from "/home/gustavo/Documents/frontend-ivv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__